import React, { useState } from 'react';
import { ArrowDownToLine, Eye, TrendingUp, Zap, DollarSign, Repeat, X, Globe, ChevronDown, Star } from 'lucide-react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
interface StatsTabProps {
  showToast: (msg: string) => void;
  setActiveTab: (tab: string) => void;
}
export function StatsTab({
  showToast,
  setActiveTab
}: StatsTabProps) {
  const [statsPeriod, setStatsPeriod] = useState('month');
  const [expandedStatCard, setExpandedStatCard] = useState<string | null>(null);
  const [selectedBarMonth, setSelectedBarMonth] = useState<number | null>(null);
  const [statsSortBy, setStatsSortBy] = useState('revenue');
  const [statsSortDir, setStatsSortDir] = useState<'asc' | 'desc'>('desc');
  return <div className="space-y-6" data-id="element-13153">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-6" data-id="element-13154">
        <h2 className="text-2xl font-bold text-slate-900" data-id="element-13155">Аналитика</h2>
        <div className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto" data-id="element-13156">
          <div className="flex gap-1.5 bg-white p-1.5 rounded-xl border border-slate-100 shadow-sm overflow-x-auto w-full sm:w-auto scrollbar-hide" data-id="element-13157">
            {[{
            id: 'week',
            label: 'Неделя'
          }, {
            id: 'month',
            label: 'Месяц'
          }, {
            id: 'quarter',
            label: 'Квартал'
          }, {
            id: 'year',
            label: 'Год'
          }].map(period => <button key={period.id} onClick={() => setStatsPeriod(period.id)} className={`px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-colors flex-1 sm:flex-none text-center ${statsPeriod === period.id ? 'bg-indigo-50 text-indigo-700' : 'text-slate-600 hover:bg-slate-50'}`} data-id="element-13158">
                {period.label}
              </button>)}
          </div>
          <Button variant="outline" icon={<ArrowDownToLine className="w-4 h-4" data-id="element-13160" />} onClick={() => showToast('Отчёт скачивается...')} className="w-full sm:w-auto" data-id="element-13159">
            Скачать отчёт
          </Button>
        </div>
      </div>

      {/* 4 Interactive Stat Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-13161">
        <Card padding="md" className={`cursor-pointer transition-all hover:border-primary hover:shadow-md ${expandedStatCard === 'views' ? 'border-primary ring-1 ring-primary' : ''}`} onClick={() => setExpandedStatCard(expandedStatCard === 'views' ? null : 'views')} data-id="element-13162">
          <div className="flex justify-between items-start mb-2" data-id="element-13163">
            <div className="text-sm text-slate-500" data-id="element-13164">Просмотры профиля</div>
            <Eye className={`w-4 h-4 ${expandedStatCard === 'views' ? 'text-primary' : 'text-slate-400'}`} data-id="element-13165" />
          </div>
          <div className="text-2xl font-bold text-slate-900 mb-2" data-id="element-13166">1,247</div>
          <div className="text-xs text-emerald-600 flex items-center font-medium" data-id="element-13167">
            <TrendingUp className="w-3 h-3 mr-1" data-id="element-13168" /> +15% за месяц
          </div>
        </Card>

        <Card padding="md" className={`cursor-pointer transition-all hover:border-primary hover:shadow-md ${expandedStatCard === 'conversion' ? 'border-primary ring-1 ring-primary' : ''}`} onClick={() => setExpandedStatCard(expandedStatCard === 'conversion' ? null : 'conversion')} data-id="element-13169">
          <div className="flex justify-between items-start mb-2" data-id="element-13170">
            <div className="text-sm text-slate-500" data-id="element-13171">Конверсия в заказ</div>
            <Zap className={`w-4 h-4 ${expandedStatCard === 'conversion' ? 'text-primary' : 'text-slate-400'}`} data-id="element-13172" />
          </div>
          <div className="text-2xl font-bold text-slate-900 mb-2" data-id="element-13173">8.3%</div>
          <div className="text-xs text-emerald-600 flex items-center font-medium" data-id="element-13174">
            <TrendingUp className="w-3 h-3 mr-1" data-id="element-13175" /> +1.2% за месяц
          </div>
        </Card>

        <Card padding="md" className={`cursor-pointer transition-all hover:border-primary hover:shadow-md ${expandedStatCard === 'avgCheck' ? 'border-primary ring-1 ring-primary' : ''}`} onClick={() => setExpandedStatCard(expandedStatCard === 'avgCheck' ? null : 'avgCheck')} data-id="element-13176">
          <div className="flex justify-between items-start mb-2" data-id="element-13177">
            <div className="text-sm text-slate-500" data-id="element-13178">Средний чек</div>
            <DollarSign className={`w-4 h-4 ${expandedStatCard === 'avgCheck' ? 'text-primary' : 'text-slate-400'}`} data-id="element-13179" />
          </div>
          <div className="text-2xl font-bold text-slate-900 mb-2" data-id="element-13180">4,800 ₽</div>
          <div className="text-xs text-slate-500 flex items-center font-medium" data-id="element-13181">
            Без изменений
          </div>
        </Card>

        <Card padding="md" className={`cursor-pointer transition-all hover:border-primary hover:shadow-md ${expandedStatCard === 'repeat' ? 'border-primary ring-1 ring-primary' : ''}`} onClick={() => setExpandedStatCard(expandedStatCard === 'repeat' ? null : 'repeat')} data-id="element-13182">
          <div className="flex justify-between items-start mb-2" data-id="element-13183">
            <div className="text-sm text-slate-500" data-id="element-13184">Повторные клиенты</div>
            <Repeat className={`w-4 h-4 ${expandedStatCard === 'repeat' ? 'text-primary' : 'text-slate-400'}`} data-id="element-13185" />
          </div>
          <div className="text-2xl font-bold text-slate-900 mb-2" data-id="element-13186">34%</div>
          <div className="text-xs text-emerald-600 flex items-center font-medium" data-id="element-13187">
            <TrendingUp className="w-3 h-3 mr-1" data-id="element-13188" /> +5% за месяц
          </div>
        </Card>
      </div>

      {/* Expanded Detail Panels */}
      {expandedStatCard === 'views' && <div className="animate-in fade-in slide-in-from-top-4 duration-300" data-id="element-13189">
          <Card padding="lg" className="bg-indigo-50/50 border-indigo-100 relative" data-id="element-13190">
            <button onClick={() => setExpandedStatCard(null)} className="absolute top-4 right-4 p-1 text-slate-400 hover:text-slate-600 rounded-full hover:bg-white transition-colors" data-id="element-13191">
              <X className="w-4 h-4" data-id="element-13192" />
            </button>
            <h3 className="font-bold text-slate-900 mb-4 flex items-center gap-2" data-id="element-13193">
              <Eye className="w-5 h-5 text-indigo-500" data-id="element-13194" /> Детализация просмотров
            </h3>
            <div className="space-y-3" data-id="element-13195">
              {[{
            day: 'Сегодня',
            val: 42,
            width: '100%'
          }, {
            day: 'Вчера',
            val: 38,
            width: '90%'
          }, {
            day: 'Позавчера',
            val: 45,
            width: '105%'
          }, {
            day: '3 дня назад',
            val: 30,
            width: '70%'
          }, {
            day: '4 дня назад',
            val: 25,
            width: '60%'
          }, {
            day: '5 дней назад',
            val: 35,
            width: '85%'
          }, {
            day: '6 дней назад',
            val: 40,
            width: '95%'
          }].map((d, i) => <div key={i} className="flex items-center gap-4" data-id="element-13196">
                  <div className="w-24 text-sm text-slate-600" data-id="element-13197">{d.day}</div>
                  <div className="flex-1" data-id="element-13198">
                    <div className="h-2 bg-indigo-200 rounded-full" style={{
                width: d.width
              }} data-id="element-13199"></div>
                  </div>
                  <div className="w-12 text-right text-sm font-medium text-slate-900" data-id="element-13200">
                    {d.val}
                  </div>
                </div>)}
            </div>
          </Card>
        </div>}

      {expandedStatCard === 'conversion' && <div className="animate-in fade-in slide-in-from-top-4 duration-300" data-id="element-13201">
          <Card padding="lg" className="bg-indigo-50/50 border-indigo-100 relative" data-id="element-13202">
            <button onClick={() => setExpandedStatCard(null)} className="absolute top-4 right-4 p-1 text-slate-400 hover:text-slate-600 rounded-full hover:bg-white transition-colors" data-id="element-13203">
              <X className="w-4 h-4" data-id="element-13204" />
            </button>
            <h3 className="font-bold text-slate-900 mb-6 flex items-center gap-2" data-id="element-13205">
              <Zap className="w-5 h-5 text-indigo-500" data-id="element-13206" /> Воронка продаж
            </h3>
            <div className="space-y-4 max-w-2xl mx-auto" data-id="element-13207">
              <div className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm flex justify-between items-center" data-id="element-13208">
                <div className="flex items-center gap-3" data-id="element-13209">
                  <div className="w-8 h-8 rounded-full bg-slate-100 flex items-center justify-center text-slate-500 font-bold" data-id="element-13210">
                    1
                  </div>
                  <span className="font-medium text-slate-700" data-id="element-13211">
                    Просмотры профиля
                  </span>
                </div>
                <span className="font-bold text-slate-900 text-lg" data-id="element-13212">1,247</span>
              </div>
              <div className="flex justify-center -my-2 relative z-10" data-id="element-13213">
                <div className="bg-indigo-100 text-indigo-700 text-xs font-bold px-3 py-1 rounded-full border border-white" data-id="element-13214">
                  Конверсия 24%
                </div>
              </div>
              <div className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm flex justify-between items-center mx-4" data-id="element-13215">
                <div className="flex items-center gap-3" data-id="element-13216">
                  <div className="w-8 h-8 rounded-full bg-indigo-100 flex items-center justify-center text-indigo-600 font-bold" data-id="element-13217">
                    2
                  </div>
                  <span className="font-medium text-slate-700" data-id="element-13218">
                    Начали диалог / Контакты
                  </span>
                </div>
                <span className="font-bold text-slate-900 text-lg" data-id="element-13219">298</span>
              </div>
              <div className="flex justify-center -my-2 relative z-10" data-id="element-13220">
                <div className="bg-emerald-100 text-emerald-700 text-xs font-bold px-3 py-1 rounded-full border border-white" data-id="element-13221">
                  Конверсия 35%
                </div>
              </div>
              <div className="bg-white p-4 rounded-xl border border-emerald-200 shadow-sm flex justify-between items-center mx-8 ring-1 ring-emerald-100" data-id="element-13222">
                <div className="flex items-center gap-3" data-id="element-13223">
                  <div className="w-8 h-8 rounded-full bg-emerald-100 flex items-center justify-center text-emerald-600 font-bold" data-id="element-13224">
                    3
                  </div>
                  <span className="font-medium text-slate-700" data-id="element-13225">
                    Оплаченные заказы
                  </span>
                </div>
                <span className="font-bold text-emerald-600 text-lg" data-id="element-13226">104</span>
              </div>
            </div>
          </Card>
        </div>}

      {expandedStatCard === 'avgCheck' && <div className="animate-in fade-in slide-in-from-top-4 duration-300" data-id="element-13227">
          <Card padding="lg" className="bg-indigo-50/50 border-indigo-100 relative" data-id="element-13228">
            <button onClick={() => setExpandedStatCard(null)} className="absolute top-4 right-4 p-1 text-slate-400 hover:text-slate-600 rounded-full hover:bg-white transition-colors" data-id="element-13229">
              <X className="w-4 h-4" data-id="element-13230" />
            </button>
            <h3 className="font-bold text-slate-900 mb-6 flex items-center gap-2" data-id="element-13231">
              <DollarSign className="w-5 h-5 text-indigo-500" data-id="element-13232" /> Распределение
              чеков
            </h3>
            <div className="space-y-6" data-id="element-13233">
              <div data-id="element-13234">
                <div className="flex justify-between text-sm mb-2" data-id="element-13235">
                  <span className="font-medium text-slate-700" data-id="element-13236">
                    До 3 000 ₽ (Мелкие услуги)
                  </span>
                  <span className="font-bold text-slate-900" data-id="element-13237">20%</span>
                </div>
                <div className="w-full bg-slate-200 rounded-full h-3" data-id="element-13238">
                  <div className="bg-indigo-300 h-3 rounded-full" style={{
                width: '20%'
              }} data-id="element-13239"></div>
                </div>
              </div>
              <div data-id="element-13240">
                <div className="flex justify-between text-sm mb-2" data-id="element-13241">
                  <span className="font-medium text-slate-700" data-id="element-13242">
                    3 000 - 5 000 ₽ (Стандартные разборы)
                  </span>
                  <span className="font-bold text-slate-900" data-id="element-13243">55%</span>
                </div>
                <div className="w-full bg-slate-200 rounded-full h-3" data-id="element-13244">
                  <div className="bg-indigo-500 h-3 rounded-full" style={{
                width: '55%'
              }} data-id="element-13245"></div>
                </div>
              </div>
              <div data-id="element-13246">
                <div className="flex justify-between text-sm mb-2" data-id="element-13247">
                  <span className="font-medium text-slate-700" data-id="element-13248">
                    Более 5 000 ₽ (Пакеты и консультации)
                  </span>
                  <span className="font-bold text-slate-900" data-id="element-13249">25%</span>
                </div>
                <div className="w-full bg-slate-200 rounded-full h-3" data-id="element-13250">
                  <div className="bg-indigo-700 h-3 rounded-full" style={{
                width: '25%'
              }} data-id="element-13251"></div>
                </div>
              </div>
            </div>
          </Card>
        </div>}

      {expandedStatCard === 'repeat' && <div className="animate-in fade-in slide-in-from-top-4 duration-300" data-id="element-13252">
          <Card padding="lg" className="bg-indigo-50/50 border-indigo-100 relative" data-id="element-13253">
            <button onClick={() => setExpandedStatCard(null)} className="absolute top-4 right-4 p-1 text-slate-400 hover:text-slate-600 rounded-full hover:bg-white transition-colors" data-id="element-13254">
              <X className="w-4 h-4" data-id="element-13255" />
            </button>
            <h3 className="font-bold text-slate-900 mb-6 flex items-center gap-2" data-id="element-13256">
              <Repeat className="w-5 h-5 text-indigo-500" data-id="element-13257" /> Структура клиентов
            </h3>
            <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-13258">
              <div className="relative w-48 h-48 flex-shrink-0" data-id="element-13259">
                <svg viewBox="0 0 100 100" className="w-full h-full transform -rotate-90" data-id="element-13260">
                  <circle cx="50" cy="50" r="40" fill="transparent" stroke="#e2e8f0" strokeWidth="20" data-id="element-13261" />
                  <circle cx="50" cy="50" r="40" fill="transparent" stroke="#6366f1" strokeWidth="20" strokeDasharray="251.2" strokeDashoffset="165.8" className="transition-all duration-1000" data-id="element-13262" />
                </svg>
                <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-13263">
                  <span className="text-3xl font-bold text-slate-900" data-id="element-13264">104</span>
                  <span className="text-xs text-slate-500" data-id="element-13265">клиента</span>
                </div>
              </div>
              <div className="flex-1 space-y-4 w-full" data-id="element-13266">
                <div className="bg-white p-4 rounded-xl border border-slate-200 shadow-sm flex items-center justify-between" data-id="element-13267">
                  <div className="flex items-center gap-3" data-id="element-13268">
                    <div className="w-4 h-4 rounded-full bg-slate-200" data-id="element-13269"></div>
                    <div data-id="element-13270">
                      <div className="font-bold text-slate-900" data-id="element-13271">
                        Новые клиенты
                      </div>
                      <div className="text-xs text-slate-500" data-id="element-13272">Первый заказ</div>
                    </div>
                  </div>
                  <div className="text-right" data-id="element-13273">
                    <div className="font-bold text-slate-900 text-lg" data-id="element-13274">66%</div>
                    <div className="text-xs text-slate-500" data-id="element-13275">69 чел.</div>
                  </div>
                </div>
                <div className="bg-white p-4 rounded-xl border border-indigo-200 shadow-sm flex items-center justify-between ring-1 ring-indigo-50" data-id="element-13276">
                  <div className="flex items-center gap-3" data-id="element-13277">
                    <div className="w-4 h-4 rounded-full bg-indigo-500" data-id="element-13278"></div>
                    <div data-id="element-13279">
                      <div className="font-bold text-indigo-900" data-id="element-13280">
                        Повторные клиенты
                      </div>
                      <div className="text-xs text-indigo-500" data-id="element-13281">
                        2 и более заказов
                      </div>
                    </div>
                  </div>
                  <div className="text-right" data-id="element-13282">
                    <div className="font-bold text-indigo-600 text-lg" data-id="element-13283">34%</div>
                    <div className="text-xs text-indigo-400" data-id="element-13284">35 чел.</div>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        </div>}

      {/* Order Dynamics Chart */}
      <Card padding="lg" data-id="element-13285">
        <h3 className="font-bold text-slate-900 mb-6" data-id="element-13286">
          Динамика заказов (последние 6 месяцев)
        </h3>
        <div className="h-64 flex items-end justify-between gap-2 pt-4 border-b border-slate-100 pb-2" data-id="element-13287">
          {[{
          month: 'Май',
          height: '40%',
          val: '24',
          revenue: '115 000',
          newClients: 18,
          avg: '4 790'
        }, {
          month: 'Июн',
          height: '55%',
          val: '32',
          revenue: '154 000',
          newClients: 22,
          avg: '4 810'
        }, {
          month: 'Июл',
          height: '45%',
          val: '28',
          revenue: '135 000',
          newClients: 19,
          avg: '4 820'
        }, {
          month: 'Авг',
          height: '70%',
          val: '45',
          revenue: '216 000',
          newClients: 31,
          avg: '4 800'
        }, {
          month: 'Сен',
          height: '85%',
          val: '52',
          revenue: '250 000',
          newClients: 35,
          avg: '4 800'
        }, {
          month: 'Окт',
          height: '100%',
          val: '64',
          revenue: '307 000',
          newClients: 42,
          avg: '4 800'
        }].map((bar, i) => <div key={i} className="flex flex-col items-center flex-1 group cursor-pointer" onClick={() => setSelectedBarMonth(selectedBarMonth === i ? null : i)} data-id="element-13288">
              <div className={`text-xs mb-2 transition-opacity ${selectedBarMonth === i ? 'opacity-100 text-primary font-bold' : 'opacity-0 group-hover:opacity-100 text-slate-400'}`} data-id="element-13289">
                {bar.val}
              </div>
              <div className={`w-full max-w-[40px] transition-colors rounded-t-md relative ${selectedBarMonth === i ? 'bg-primary' : 'bg-primary/20 group-hover:bg-primary/60'}`} style={{
            height: bar.height
          }} data-id="element-13290"></div>
              <div className={`text-xs mt-2 font-medium ${selectedBarMonth === i ? 'text-primary' : 'text-slate-500'}`} data-id="element-13291">
                {bar.month}
              </div>
            </div>)}
        </div>

        {/* Detail panel for selected month */}
        {selectedBarMonth !== null && <div className="mt-6 p-4 bg-slate-50 rounded-xl border border-slate-100 animate-in fade-in slide-in-from-top-2" data-id="element-13292">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" data-id="element-13293">
              <div data-id="element-13294">
                <h4 className="font-bold text-slate-900 mb-1" data-id="element-13295">
                  Итоги за{' '}
                  {['Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь'][selectedBarMonth]}
                </h4>
                <div className="flex flex-wrap gap-4 text-sm" data-id="element-13296">
                  <span className="text-slate-600" data-id="element-13297">
                    Заказов:{' '}
                    <strong className="text-slate-900" data-id="element-13298">
                      {[24, 32, 28, 45, 52, 64][selectedBarMonth]}
                    </strong>
                  </span>
                  <span className="text-slate-600" data-id="element-13299">
                    Выручка:{' '}
                    <strong className="text-emerald-600" data-id="element-13300">
                      {['115 000', '154 000', '135 000', '216 000', '250 000', '307 000'][selectedBarMonth]}{' '}
                      ₽
                    </strong>
                  </span>
                  <span className="text-slate-600" data-id="element-13301">
                    Новых клиентов:{' '}
                    <strong className="text-slate-900" data-id="element-13302">
                      {[18, 22, 19, 31, 35, 42][selectedBarMonth]}
                    </strong>
                  </span>
                  <span className="text-slate-600" data-id="element-13303">
                    Средний чек:{' '}
                    <strong className="text-slate-900" data-id="element-13304">
                      {['4 790', '4 810', '4 820', '4 800', '4 800', '4 800'][selectedBarMonth]}{' '}
                      ₽
                    </strong>
                  </span>
                </div>
              </div>
              <Button variant="outline" size="sm" onClick={() => setActiveTab('orders')} className="whitespace-nowrap" data-id="element-13305">
                Перейти к заказам
              </Button>
            </div>
          </div>}
      </Card>

      {/* 2-Column Grid: Traffic & Geography */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6" data-id="element-13306">
        {/* Traffic Sources */}
        <Card padding="lg" data-id="element-13307">
          <h3 className="font-bold text-slate-900 mb-6" data-id="element-13308">Источники клиентов</h3>
          <div className="space-y-5" data-id="element-13309">
            {[{
            name: 'Каталог астрологов',
            percent: 52,
            color: 'bg-indigo-500'
          }, {
            name: 'Поиск на платформе',
            percent: 28,
            color: 'bg-sky-400'
          }, {
            name: 'Прямая ссылка',
            percent: 12,
            color: 'bg-emerald-400'
          }, {
            name: 'Рекомендации',
            percent: 8,
            color: 'bg-amber-400'
          }].map((source, i) => <div key={i} className="cursor-pointer group" onClick={() => showToast(`Детализация по источнику: ${source.name}`)} data-id="element-13310">
                <div className="flex justify-between text-sm mb-1.5" data-id="element-13311">
                  <span className="font-medium text-slate-700 group-hover:text-primary transition-colors" data-id="element-13312">
                    {source.name}
                  </span>
                  <span className="font-bold text-slate-900" data-id="element-13313">
                    {source.percent}%
                  </span>
                </div>
                <div className="w-full bg-slate-100 rounded-full h-2.5 overflow-hidden" data-id="element-13314">
                  <div className={`h-full ${source.color} rounded-full group-hover:opacity-80 transition-opacity`} style={{
                width: `${source.percent}%`
              }} data-id="element-13315"></div>
                </div>
              </div>)}
          </div>
        </Card>

        {/* Client Geography */}
        <Card padding="lg" data-id="element-13316">
          <h3 className="font-bold text-slate-900 mb-6 flex items-center gap-2" data-id="element-13317">
            <Globe className="w-5 h-5 text-slate-400" data-id="element-13318" /> География клиентов
          </h3>
          <div className="space-y-4" data-id="element-13319">
            {[{
            city: 'Москва',
            percent: 35
          }, {
            city: 'Санкт-Петербург',
            percent: 18
          }, {
            city: 'Казань',
            percent: 8
          }, {
            city: 'Новосибирск',
            percent: 7
          }, {
            city: 'Екатеринбург',
            percent: 5
          }].map((geo, i) => <div key={i} className="flex items-center gap-3 cursor-pointer group" onClick={() => showToast(`Клиенты из г. ${geo.city}`)} data-id="element-13320">
                <div className="w-5 text-center text-xs font-bold text-slate-400" data-id="element-13321">
                  {i + 1}
                </div>
                <div className="flex-1" data-id="element-13322">
                  <div className="flex justify-between text-sm mb-1" data-id="element-13323">
                    <span className="font-medium text-slate-700 group-hover:text-primary transition-colors" data-id="element-13324">
                      {geo.city}
                    </span>
                    <span className="font-bold text-slate-900" data-id="element-13325">
                      {geo.percent}%
                    </span>
                  </div>
                  <div className="w-full bg-slate-100 rounded-full h-1.5" data-id="element-13326">
                    <div className="bg-slate-400 h-full rounded-full group-hover:bg-primary transition-colors" style={{
                  width: `${geo.percent}%`
                }} data-id="element-13327"></div>
                  </div>
                </div>
              </div>)}
            <div className="pt-2 mt-2 border-t border-slate-100 text-sm text-slate-500 text-center cursor-pointer hover:text-primary transition-colors" onClick={() => showToast('Показать все города')} data-id="element-13328">
              Другие города: 27%
            </div>
          </div>
        </Card>
      </div>

      {/* Top Services Table */}
      <Card padding="none" className="overflow-hidden" data-id="element-13329">
        <div className="p-6 border-b border-slate-100 flex justify-between items-center" data-id="element-13330">
          <h3 className="font-bold text-slate-900" data-id="element-13331">Топ услуги по заказам</h3>
        </div>
        <div className="overflow-x-auto" data-id="element-13332">
          <table className="w-full text-left text-sm" data-id="element-13333">
            <thead className="bg-slate-50 text-slate-500" data-id="element-13334">
              <tr data-id="element-13335">
                <th className="px-6 py-4 font-medium" data-id="element-13336">Услуга</th>
                <th className="px-6 py-4 font-medium cursor-pointer hover:text-slate-900 transition-colors" onClick={() => {
                setStatsSortBy('orders');
                setStatsSortDir(statsSortDir === 'asc' ? 'desc' : 'asc');
              }} data-id="element-13337">
                  <div className="flex items-center gap-1" data-id="element-13338">
                    Заказы
                    <ChevronDown className={`w-3 h-3 transition-transform ${statsSortBy === 'orders' ? 'text-primary' : ''} ${statsSortBy === 'orders' && statsSortDir === 'asc' ? 'rotate-180' : ''}`} data-id="element-13339" />
                  </div>
                </th>
                <th className="px-6 py-4 font-medium cursor-pointer hover:text-slate-900 transition-colors" onClick={() => {
                setStatsSortBy('conversion');
                setStatsSortDir(statsSortDir === 'asc' ? 'desc' : 'asc');
              }} data-id="element-13340">
                  <div className="flex items-center gap-1" data-id="element-13341">
                    Конверсия
                    <ChevronDown className={`w-3 h-3 transition-transform ${statsSortBy === 'conversion' ? 'text-primary' : ''} ${statsSortBy === 'conversion' && statsSortDir === 'asc' ? 'rotate-180' : ''}`} data-id="element-13342" />
                  </div>
                </th>
                <th className="px-6 py-4 font-medium text-right cursor-pointer hover:text-slate-900 transition-colors" onClick={() => {
                setStatsSortBy('revenue');
                setStatsSortDir(statsSortDir === 'asc' ? 'desc' : 'asc');
              }} data-id="element-13343">
                  <div className="flex items-center justify-end gap-1" data-id="element-13344">
                    Выручка
                    <ChevronDown className={`w-3 h-3 transition-transform ${statsSortBy === 'revenue' ? 'text-primary' : ''} ${statsSortBy === 'revenue' && statsSortDir === 'asc' ? 'rotate-180' : ''}`} data-id="element-13345" />
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-13346">
              {[{
              name: 'Натальная карта (Видео)',
              orders: 42,
              conv: '12.4%',
              rev: '210,000 ₽'
            }, {
              name: 'Соляр на год (Чат)',
              orders: 28,
              conv: '9.8%',
              rev: '112,000 ₽'
            }, {
              name: 'Синастрия',
              orders: 15,
              conv: '5.2%',
              rev: '90,000 ₽'
            }].map((svc, i) => <tr key={i} className="hover:bg-slate-50 cursor-pointer transition-colors" onClick={() => {
              showToast(`Переход к заказам по услуге: ${svc.name}`);
              setActiveTab('orders');
            }} data-id="element-13347">
                  <td className="px-6 py-4 font-medium text-slate-900" data-id="element-13348">
                    {svc.name}
                  </td>
                  <td className="px-6 py-4 text-slate-600" data-id="element-13349">{svc.orders}</td>
                  <td className="px-6 py-4 text-emerald-600" data-id="element-13350">{svc.conv}</td>
                  <td className="px-6 py-4 text-right font-medium text-slate-900" data-id="element-13351">
                    {svc.rev}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        <div className="p-4 bg-slate-50 border-t border-slate-100 text-center" data-id="element-13352">
          <button className="text-sm font-medium text-primary hover:text-indigo-700 transition-colors" onClick={() => setActiveTab('products')} data-id="element-13353">
            Управление всеми услугами
          </button>
        </div>
      </Card>

      {/* Reviews Analytics */}
      <Card padding="lg" data-id="element-13354">
        <div className="flex flex-col md:flex-row gap-8" data-id="element-13355">
          <div className="md:w-1/3 flex flex-col items-center justify-center border-b md:border-b-0 md:border-r border-slate-100 pb-6 md:pb-0 md:pr-6" data-id="element-13356">
            <h3 className="font-bold text-slate-900 mb-4 w-full text-left" data-id="element-13357">
              Отзывы и рейтинг
            </h3>
            <div className="text-6xl font-black text-slate-900 mb-2" data-id="element-13358">4.9</div>
            <div className="flex gap-1 mb-2" data-id="element-13359">
              {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-6 h-6 text-amber-400 fill-amber-400" data-id="element-13360" />)}
            </div>
            <div className="text-sm text-slate-500" data-id="element-13361">124 отзыва</div>

            <div className="w-full mt-6 space-y-2" data-id="element-13362">
              {[{
              stars: 5,
              percent: 85
            }, {
              stars: 4,
              percent: 10
            }, {
              stars: 3,
              percent: 3
            }, {
              stars: 2,
              percent: 1
            }, {
              stars: 1,
              percent: 1
            }].map(row => <div key={row.stars} className="flex items-center gap-2 text-xs" data-id="element-13363">
                  <div className="w-3 text-slate-500" data-id="element-13364">{row.stars}</div>
                  <Star className="w-3 h-3 text-slate-400" data-id="element-13365" />
                  <div className="flex-1 h-1.5 bg-slate-100 rounded-full overflow-hidden" data-id="element-13366">
                    <div className="h-full bg-amber-400 rounded-full" style={{
                  width: `${row.percent}%`
                }} data-id="element-13367"></div>
                  </div>
                  <div className="w-6 text-right text-slate-500" data-id="element-13368">
                    {row.percent}%
                  </div>
                </div>)}
            </div>
          </div>

          <div className="md:w-2/3 flex flex-col" data-id="element-13369">
            <h4 className="font-bold text-slate-900 mb-4" data-id="element-13370">Последние отзывы</h4>
            <div className="space-y-4 flex-1" data-id="element-13371">
              {[{
              name: 'Мария В.',
              date: 'Вчера',
              rating: 5,
              text: 'Очень подробный разбор! Елена ответила на все мои вопросы и помогла разобраться в сложной ситуации. Рекомендую!'
            }, {
              name: 'Дмитрий Р.',
              date: '3 дня назад',
              rating: 5,
              text: 'Брал консультацию по синастрии. Всё четко, по делу, без лишней воды. Спасибо.'
            }, {
              name: 'Анна К.',
              date: 'Неделю назад',
              rating: 4,
              text: 'Хороший соляр, много полезной информации. Единственное — пришлось подождать ответа чуть дольше обещанного.'
            }].map((review, i) => <div key={i} className="bg-slate-50 p-4 rounded-xl border border-slate-100" data-id="element-13372">
                  <div className="flex justify-between items-start mb-2" data-id="element-13373">
                    <div data-id="element-13374">
                      <div className="font-bold text-slate-900 text-sm" data-id="element-13375">
                        {review.name}
                      </div>
                      <div className="text-[10px] text-slate-500" data-id="element-13376">
                        {review.date}
                      </div>
                    </div>
                    <div className="flex gap-0.5" data-id="element-13377">
                      {[...Array(5)].map((_, j) => <Star key={j} className={`w-3.5 h-3.5 ${j < review.rating ? 'text-amber-400 fill-amber-400' : 'text-slate-300'}`} data-id="element-13378" />)}
                    </div>
                  </div>
                  <p className="text-sm text-slate-600 mb-3" data-id="element-13379">{review.text}</p>
                  <button onClick={() => {
                showToast('Открытие чата с клиентом...');
                setActiveTab('chat');
              }} className="text-xs font-medium text-primary hover:text-indigo-700 transition-colors" data-id="element-13380">
                    Ответить
                  </button>
                </div>)}
            </div>
            <div className="mt-4 pt-4 border-t border-slate-100 text-center" data-id="element-13381">
              <button className="text-sm font-medium text-slate-600 hover:text-primary transition-colors" onClick={() => showToast('Открытие всех отзывов...')} data-id="element-13382">
                Смотреть все отзывы
              </button>
            </div>
          </div>
        </div>
      </Card>
    </div>;
}